import { render } from "./ShiftsCard.vue?vue&type=template&id=22d83243&ts=true"
import script from "./ShiftsCard.vue?vue&type=script&lang=ts"
export * from "./ShiftsCard.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__